/* ============================================================
   THELUNELLES — Theme JavaScript
   ============================================================ */

'use strict';

/* ============================================================
   REVEAL ON SCROLL
   ============================================================ */
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('revealed');
      revealObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.1 });

document.querySelectorAll('[data-reveal]').forEach(el => revealObserver.observe(el));

/* ============================================================
   HEADER SCROLL EFFECT
   ============================================================ */
const siteHeader = document.querySelector('.site-header');
if (siteHeader) {
  window.addEventListener('scroll', () => {
    siteHeader.classList.toggle('scrolled', window.scrollY > 50);
  }, { passive: true });
}

/* ============================================================
   MOBILE MENU
   ============================================================ */
const mobileToggle = document.querySelector('.mobile-menu-toggle');
const mobileNav    = document.querySelector('.mobile-nav');
const overlay      = document.querySelector('#overlay');

function openMobileNav() {
  mobileToggle?.classList.add('active');
  mobileNav?.classList.add('open');
  overlay?.classList.add('active');
  document.body.style.overflow = 'hidden';
}

function closeMobileNav() {
  mobileToggle?.classList.remove('active');
  mobileNav?.classList.remove('open');
  overlay?.classList.remove('active');
  document.body.style.overflow = '';
}

mobileToggle?.addEventListener('click', () => {
  mobileNav?.classList.contains('open') ? closeMobileNav() : openMobileNav();
});

document.querySelector('.mobile-nav__close')?.addEventListener('click', closeMobileNav);
overlay?.addEventListener('click', () => {
  closeMobileNav();
  closeCartDrawer();
});

/* ============================================================
   CART DRAWER
   ============================================================ */
const cartDrawer = document.getElementById('cart-drawer');

function openCartDrawer() {
  cartDrawer?.setAttribute('aria-hidden', 'false');
  overlay?.classList.add('active');
  document.body.style.overflow = 'hidden';
  fetchCart();
}

function closeCartDrawer() {
  cartDrawer?.setAttribute('aria-hidden', 'true');
  overlay?.classList.remove('active');
  document.body.style.overflow = '';
}

document.querySelector('.cart-drawer__close')?.addEventListener('click', closeCartDrawer);
document.querySelector('.cart-drawer__overlay')?.addEventListener('click', closeCartDrawer);

document.querySelectorAll('[data-cart-toggle]').forEach(btn => {
  btn.addEventListener('click', openCartDrawer);
});

async function fetchCart() {
  const content = document.getElementById('cart-drawer-content');
  if (!content) return;
  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    renderCart(cart, content);
  } catch (e) {
    console.error('Cart fetch error:', e);
  }
}

function renderCart(cart, container) {
  if (cart.items.length === 0) {
    container.innerHTML = `
      <div style="text-align:center;padding:4rem 2rem;">
        <svg style="width:5rem;height:5rem;margin:0 auto 2rem;display:block;opacity:0.3" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
          <line x1="3" y1="6" x2="21" y2="6"/>
          <path d="M16 10a4 4 0 01-8 0"/>
        </svg>
        <p style="font-size:1.7rem;color:#888;">Sepetiniz boş</p>
        <a href="/collections/all" class="btn btn--primary mt-2" style="display:inline-flex;">Alışverişe Başla</a>
      </div>`;
    return;
  }

  const itemsHTML = cart.items.map(item => `
    <div class="cart-item" data-key="${item.key}">
      <img class="cart-item__image" src="${item.image}" alt="${item.title}" width="90" height="120">
      <div>
        <p class="cart-item__title">${item.product_title}</p>
        <p class="cart-item__variant">${item.variant_title || ''}</p>
        <div style="display:flex;align-items:center;justify-content:space-between;margin-top:1rem;">
          <div class="quantity-selector" style="border-width:1px;">
            <button class="quantity-btn" data-action="decrease" data-key="${item.key}" data-qty="${item.quantity}">−</button>
            <input class="quantity-input" type="number" value="${item.quantity}" min="0" data-key="${item.key}" style="width:4rem;height:3.8rem;border-width:1px;">
            <button class="quantity-btn" data-action="increase" data-key="${item.key}" data-qty="${item.quantity}">+</button>
          </div>
          <p class="cart-item__price">${formatMoney(item.final_line_price)}</p>
        </div>
      </div>
    </div>`).join('');

  container.innerHTML = `
    <div class="cart-drawer__content">${itemsHTML}</div>
    <div class="cart-drawer__footer">
      <div class="cart-subtotal">
        <span>Ara Toplam</span>
        <span class="cart-subtotal__amount">${formatMoney(cart.total_price)}</span>
      </div>
      <a href="/checkout" class="btn btn--primary btn--full">Ödemeye Geç</a>
      <a href="/cart" class="btn btn--outline btn--full">Sepeti Görüntüle</a>
      <p class="cart-note">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>
        Güvenli ve şifreli ödeme
      </p>
    </div>`;

  // Quantity buttons
  container.querySelectorAll('.quantity-btn').forEach(btn => {
    btn.addEventListener('click', async () => {
      const key    = btn.dataset.key;
      const action = btn.dataset.action;
      const current = parseInt(btn.dataset.qty);
      const newQty  = action === 'increase' ? current + 1 : Math.max(0, current - 1);
      await updateCartItem(key, newQty);
    });
  });
}

async function updateCartItem(key, quantity) {
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    fetchCart();
    updateCartCount();
  } catch (e) { console.error(e); }
}

function formatMoney(cents) {
  return new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency: 'TRY'
  }).format(cents / 100);
}

async function updateCartCount() {
  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent  = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
  } catch (e) {}
}

updateCartCount();

/* ============================================================
   ADD TO CART
   ============================================================ */
async function addToCart(variantId, quantity = 1, btn = null) {
  if (btn) {
    btn.disabled    = true;
    btn.innerHTML   = '<span class="spinner"></span>';
  }

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
    const data = await res.json();

    if (res.ok) {
      showToast('Ürün sepete eklendi!', 'success');
      updateCartCount();
      openCartDrawer();
    } else {
      showToast(data.description || 'Bir hata oluştu.', 'error');
    }
  } catch (e) {
    showToast('Bir hata oluştu.', 'error');
  } finally {
    if (btn) {
      btn.disabled  = false;
      btn.textContent = 'Sepete Ekle';
    }
  }
}

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-add-to-cart]');
  if (btn) {
    const variantId = btn.dataset.variantId || document.querySelector('[name="id"]')?.value;
    const qty       = parseInt(document.querySelector('.quantity-input')?.value || 1);
    if (variantId) addToCart(variantId, qty, btn);
  }
});

/* ============================================================
   PRODUCT GALLERY
   ============================================================ */
const galleryMain   = document.querySelector('.product-gallery__main img');
const galleryThumbs = document.querySelectorAll('.product-gallery__thumb');

galleryThumbs.forEach(thumb => {
  thumb.addEventListener('click', () => {
    galleryThumbs.forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
    if (galleryMain) {
      galleryMain.src    = thumb.querySelector('img').src.replace('_150x', '_800x');
      galleryMain.srcset = '';
    }
  });
});

/* ============================================================
   VARIANT SELECTOR
   ============================================================ */
document.querySelectorAll('.variant-option').forEach(opt => {
  opt.addEventListener('click', () => {
    const group = opt.closest('.variant-options');
    group.querySelectorAll('.variant-option').forEach(o => o.classList.remove('active'));
    opt.classList.add('active');

    const hiddenInput = document.querySelector('[name="id"]');
    if (hiddenInput && opt.dataset.variantId) {
      hiddenInput.value = opt.dataset.variantId;
    }

    // Update price display
    const price        = document.querySelector('.product-info__price');
    const comparePrice = document.querySelector('.product-info__price--compare');
    if (price && opt.dataset.price) {
      price.textContent = formatMoney(parseInt(opt.dataset.price));
    }
    if (comparePrice && opt.dataset.comparePrice) {
      comparePrice.textContent = opt.dataset.comparePrice > 0
        ? formatMoney(parseInt(opt.dataset.comparePrice))
        : '';
    }
  });
});

/* ============================================================
   QUANTITY SELECTOR
   ============================================================ */
document.querySelectorAll('.quantity-btn').forEach(btn => {
  if (btn.closest('.cart-drawer')) return;
  btn.addEventListener('click', () => {
    const input = btn.parentElement.querySelector('.quantity-input');
    if (!input) return;
    const val = parseInt(input.value) || 1;
    input.value = btn.dataset.action === 'increase' ? val + 1 : Math.max(1, val - 1);
  });
});

/* ============================================================
   ACCORDION
   ============================================================ */
document.querySelectorAll('.accordion__trigger').forEach(trigger => {
  trigger.addEventListener('click', () => {
    const item = trigger.closest('.accordion__item');
    const wasOpen = item.classList.contains('open');
    document.querySelectorAll('.accordion__item').forEach(i => i.classList.remove('open'));
    if (!wasOpen) item.classList.add('open');
  });
});

/* ============================================================
   SEARCH DRAWER
   ============================================================ */
const searchDrawer = document.querySelector('.search-drawer');

document.querySelectorAll('[data-search-toggle]').forEach(btn => {
  btn.addEventListener('click', () => {
    searchDrawer?.classList.toggle('open');
    if (searchDrawer?.classList.contains('open')) {
      searchDrawer.querySelector('input')?.focus();
    }
  });
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    searchDrawer?.classList.remove('open');
    closeCartDrawer();
    closeMobileNav();
  }
});

/* ============================================================
   TOAST NOTIFICATIONS
   ============================================================ */
function showToast(message, type = 'success') {
  let container = document.querySelector('.toast-container');
  if (!container) {
    container = document.createElement('div');
    container.className = 'toast-container';
    document.body.appendChild(container);
  }

  const toast = document.createElement('div');
  toast.className = `toast toast--${type}`;
  toast.innerHTML = `
    <svg style="width:1.6rem;height:1.6rem;flex-shrink:0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      ${type === 'success'
        ? '<path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>'
        : '<circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>'}
    </svg>
    ${message}`;
  container.appendChild(toast);

  setTimeout(() => {
    toast.style.opacity    = '0';
    toast.style.transform  = 'translateX(2rem)';
    toast.style.transition = 'all 0.3s ease';
    setTimeout(() => toast.remove(), 300);
  }, 3500);
}

/* ============================================================
   COOKIE BANNER
   ============================================================ */
const cookieBanner = document.querySelector('.cookie-banner');
if (cookieBanner && !localStorage.getItem('cookiesAccepted')) {
  setTimeout(() => cookieBanner.classList.add('show'), 2000);
  cookieBanner.querySelector('[data-accept-cookies]')?.addEventListener('click', () => {
    localStorage.setItem('cookiesAccepted', 'true');
    cookieBanner.classList.remove('show');
  });
}

/* ============================================================
   ANNOUNCEMENT BAR AUTO-SLIDE
   ============================================================ */
const announcementSlider = document.querySelector('.announcement-bar--slider');
if (announcementSlider) {
  const slides = announcementSlider.querySelectorAll('.announcement-slide');
  let current  = 0;
  if (slides.length > 1) {
    setInterval(() => {
      slides[current].style.display = 'none';
      current = (current + 1) % slides.length;
      slides[current].style.display = 'block';
    }, 4000);
  }
}

/* ============================================================
   LAZY LOAD IMAGES
   ============================================================ */
const lazyImages = document.querySelectorAll('img[data-src]');
const imgObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const img    = entry.target;
      img.src      = img.dataset.src;
      img.srcset   = img.dataset.srcset || '';
      img.removeAttribute('data-src');
      imgObserver.unobserve(img);
    }
  });
}, { rootMargin: '200px' });

lazyImages.forEach(img => imgObserver.observe(img));

/* ============================================================
   PRODUCT IMAGE ZOOM
   ============================================================ */
const mainGallery = document.querySelector('.product-gallery__main');
if (mainGallery) {
  mainGallery.addEventListener('mousemove', (e) => {
    const img    = mainGallery.querySelector('img');
    if (!img) return;
    const rect   = mainGallery.getBoundingClientRect();
    const x      = ((e.clientX - rect.left) / rect.width) * 100;
    const y      = ((e.clientY - rect.top) / rect.height) * 100;
    img.style.transformOrigin = `${x}% ${y}%`;
    img.style.transform       = 'scale(1.6)';
  });

  mainGallery.addEventListener('mouseleave', () => {
    const img = mainGallery.querySelector('img');
    if (img) {
      img.style.transform       = 'scale(1)';
      img.style.transformOrigin = 'center';
    }
  });
}

/* ============================================================
   WISHLIST
   ============================================================ */
function getWishlist() {
  return JSON.parse(localStorage.getItem('thelunelles_wishlist') || '[]');
}

function toggleWishlist(productId, btn) {
  const list = getWishlist();
  const idx  = list.indexOf(productId);
  if (idx > -1) {
    list.splice(idx, 1);
    btn?.classList.remove('active');
    showToast('Favorilerden çıkarıldı.', 'success');
  } else {
    list.push(productId);
    btn?.classList.add('active');
    showToast('Favorilere eklendi!', 'success');
  }
  localStorage.setItem('thelunelles_wishlist', JSON.stringify(list));
}

document.querySelectorAll('.wishlist-btn').forEach(btn => {
  const productId = btn.dataset.productId;
  if (productId && getWishlist().includes(productId)) btn.classList.add('active');
  btn.addEventListener('click', () => toggleWishlist(productId, btn));
});

/* ============================================================
   STICKY ADD TO CART (Product page)
   ============================================================ */
const stickyBar = document.querySelector('#sticky-atc');
const addSection = document.querySelector('.product-info__add');
if (stickyBar && addSection) {
  const obs = new IntersectionObserver((entries) => {
    stickyBar.classList.toggle('visible', !entries[0].isIntersecting);
  }, { threshold: 0 });
  obs.observe(addSection);
}

/* ============================================================
   PRODUCT PAGE FAQ ACCORDION
   ============================================================ */
document.querySelectorAll('.prd-faq-trigger').forEach(trigger => {
  trigger.addEventListener('click', () => {
    const item = trigger.closest('.prd-faq-item');
    const isOpen = item.classList.contains('open');
    document.querySelectorAll('.prd-faq-item.open').forEach(el => el.classList.remove('open'));
    if (!isOpen) item.classList.add('open');
  });
});

/* ============================================================
   CYCLING TEXT ANIMATION (Product page)
   ============================================================ */
(function initCyclingWord() {
  const el = document.getElementById('cycling-word');
  if (!el) return;
  const words = ['Yeni Dili', 'Zarafeti', 'İfadesi', 'Prestiji', 'Ruhu'];
  let i = 0;
  setInterval(() => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(8px)';
    setTimeout(() => {
      i = (i + 1) % words.length;
      el.textContent = words[i];
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    }, 300);
  }, 2400);
  el.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
})();

/* ============================================================
   STATS COUNTER ANIMATION
   ============================================================ */
(function initStats() {
  const statNumbers = document.querySelectorAll('.prd-stat-item__number');
  if (!statNumbers.length) return;

  const countObs = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      const text = el.textContent.trim();
      const match = text.match(/([\d.]+)/);
      if (!match) return;
      const target = parseFloat(match[1]);
      const prefix = text.replace(match[0], '').replace(match[0], '').split(match[0])[0];
      const suffix = text.slice(text.indexOf(match[0]) + match[0].length);
      let start = 0;
      const step = target / 60;
      const timer = setInterval(() => {
        start = Math.min(start + step, target);
        el.textContent = prefix + (Number.isInteger(target) ? Math.round(start) : start.toFixed(1)) + suffix;
        if (start >= target) clearInterval(timer);
      }, 20);
      countObs.unobserve(el);
    });
  }, { threshold: 0.4 });

  statNumbers.forEach(el => countObs.observe(el));
})();

/* ============================================================
   NEWSLETTER FORM
   ============================================================ */
document.querySelectorAll('.newsletter-form').forEach(form => {
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const email = form.querySelector('input[type="email"]')?.value;
    const btn   = form.querySelector('.newsletter-form__btn');
    if (!email) return;

    if (btn) btn.textContent = '...';
    // Shopify Contact form submission
    try {
      const body = new FormData();
      body.append('contact[email]', email);
      body.append('form_type', 'customer');
      body.append('utf8', '✓');
      await fetch('/contact', { method: 'POST', body });
    } catch (e) {}

    showToast('Bültenimize başarıyla kaydoldunuz!', 'success');
    form.reset();
    if (btn) btn.textContent = 'Kaydol';
  });
});
